var _path, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "google-play-badge",
    x: "0px",
    y: "0px",
    viewBox: "0 0 130 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "background-shape",
    fill: "#000",
    d: "M125.19 40H4.8A4.92 4.92 0 0 1 0 35V5c0-2.75 2.17-5 4.81-5H125.2A4.92 4.92 0 0 1 130 5v30c0 2.75-2.17 5-4.81 5z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "get-it-on"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M46.75 14.08h3.55v-.9h-2.62v-1.63h2.36v-.89h-2.36V9.03h2.62v-.9h-3.55zM50.88 9.03h1.61v5.05h.93V9.03h1.61v-.9h-4.15zM45.82 10.8h-2.97v.9h2.08c-.05.42-.2.75-.44 1-.41.4-.93.61-1.54.61a2.12 2.12 0 0 1-2.14-2.2 2.12 2.12 0 0 1 2.14-2.2c.64 0 1.13.2 1.5.64l.07.08.64-.64-.06-.07c-.23-.28-.54-.5-.93-.67-.39-.17-.8-.25-1.22-.25a3 3 0 0 0-2.2.9c-.59.59-.9 1.33-.9 2.2s.31 1.63.9 2.22a3 3 0 0 0 2.2.9c.89 0 1.62-.3 2.18-.89.5-.5.74-1.16.74-1.99 0-.15 0-.3-.04-.45l-.01-.08zM68.82 8a3.05 3.05 0 0 0-3.06 3.1 3.05 3.05 0 1 0 6.12 0A3.05 3.05 0 0 0 68.82 8zm0 5.31c-.59 0-1.1-.2-1.5-.62-.4-.4-.61-.94-.61-1.58s.2-1.18.61-1.59c.4-.41.91-.62 1.5-.62s1.1.2 1.5.62c.4.41.61.95.61 1.59s-.2 1.17-.61 1.58c-.4.41-.91.62-1.5.62zM57.7 8.13h.94v5.95h-.93zM76.43 8.13v3.47l.02.81-2.67-4.28h-1.06v5.95h.94V10.4l-.03-.81 2.78 4.45.03.04h.92V8.13zM59.38 9.03h1.61v5.05h.93V9.03h1.61v-.9h-4.15z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "google-play"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M65.68 22.4a4.03 4.03 0 0 0-4.1 4.08 4.04 4.04 0 0 0 4.1 4.08c2.25 0 4.1-1.73 4.1-4.08a4.03 4.03 0 0 0-4.1-4.09zm0 6.55c-1.24 0-2.31-1.02-2.31-2.47 0-1.47 1.07-2.48 2.3-2.48s2.31 1 2.31 2.48c0 1.45-1.07 2.47-2.3 2.47zM56.73 22.4a4.03 4.03 0 0 0-4.1 4.08 4.04 4.04 0 0 0 4.1 4.08c2.26 0 4.1-1.73 4.1-4.08a4.03 4.03 0 0 0-4.1-4.09zm0 6.55c-1.24 0-2.3-1.02-2.3-2.47 0-1.47 1.06-2.48 2.3-2.48 1.24 0 2.3 1 2.3 2.48 0 1.45-1.06 2.47-2.3 2.47zM46.1 23.65v1.73h4.14a3.62 3.62 0 0 1-.95 2.18c-.6.6-1.54 1.27-3.2 1.27-2.55 0-4.55-2.06-4.55-4.61a4.55 4.55 0 0 1 7.68-3.37l1.22-1.23a6.05 6.05 0 0 0-4.35-1.75 6.43 6.43 0 0 0-6.44 6.35c0 3.5 2.94 6.34 6.44 6.34a5.8 5.8 0 0 0 4.43-1.78 5.73 5.73 0 0 0 1.5-4.05c0-.4-.03-.77-.1-1.08H46.1zM89.6 25c-.34-.92-1.37-2.6-3.5-2.6-2.1 0-3.84 1.65-3.84 4.08a4 4 0 0 0 4.05 4.08 4.06 4.06 0 0 0 3.4-1.8l-1.39-.94a2.33 2.33 0 0 1-2.01 1.13c-.91 0-1.56-.41-1.98-1.23l5.46-2.26-.18-.47zm-5.56 1.35a2.24 2.24 0 0 1 2.13-2.38c.71 0 1.32.36 1.52.87l-3.65 1.51zM79.6 18.3h1.79v12.01h-1.8zM76.65 23.3h-.06a2.83 2.83 0 0 0-2.15-.9 4.06 4.06 0 0 0-3.91 4.1 4.04 4.04 0 0 0 3.91 4.06c.98 0 1.75-.43 2.15-.93h.06v.6c0 1.55-.83 2.39-2.18 2.39-1.1 0-1.78-.79-2.05-1.45l-1.57.65a3.9 3.9 0 0 0 3.62 2.4c2.1 0 3.89-1.23 3.89-4.25v-7.33h-1.7v.67zm-2.05 5.65c-1.24 0-2.28-1.03-2.28-2.46 0-1.44 1.04-2.49 2.28-2.49 1.22 0 2.18 1.05 2.18 2.5 0 1.42-.96 2.45-2.18 2.45zM98.01 18.3h-4.3v12.01h1.8v-4.54h2.5c1.99 0 3.94-1.44 3.94-3.73S100 18.3 98.01 18.3zm.05 5.8H95.5v-4.12h2.55c1.34 0 2.1 1.1 2.1 2.06a2.1 2.1 0 0 1-2.1 2.05zM109.13 22.37c-1.3 0-2.64.57-3.2 1.84l1.6.66c.34-.66.97-.88 1.63-.88.93 0 1.87.56 1.89 1.55v.12a3.96 3.96 0 0 0-1.87-.46c-1.71 0-3.46.94-3.46 2.7 0 1.6 1.4 2.64 2.98 2.64 1.2 0 1.87-.54 2.29-1.17h.06v.92h1.73v-4.6c0-2.13-1.6-3.32-3.65-3.32zm-.21 6.58c-.59 0-1.4-.3-1.4-1.02 0-.93 1.01-1.28 1.9-1.28.78 0 1.15.17 1.63.4a2.17 2.17 0 0 1-2.13 1.9zM119.08 22.63l-2.05 5.2h-.07l-2.13-5.2h-1.93l3.2 7.28-1.82 4.05h1.87l4.92-11.33zM102.94 18.3h1.8v12.01h-1.8z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "play-icon"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-blue",
    x1: 23.0756,
    x2: 6.9578,
    y1: 172.8443,
    y2: 156.7265,
    gradientTransform: "matrix(1 0 0 -1 0 182)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00a1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00beff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00d2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00dfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00e3ff"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#gradient-blue)",
    d: "M12.16 8.03c-.28.3-.44.76-.44 1.35v21.24c0 .6.16 1.05.44 1.35l.07.07 11.9-11.9v-.28l-11.9-11.9-.07.07z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-yellow",
    x1: 34.6337,
    x2: 11.395,
    y1: 161.9997,
    y2: 161.9997,
    gradientTransform: "matrix(1 0 0 -1 0 182)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#ffbd00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9c00"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#gradient-yellow)",
    d: "M28.1 24.1l-3.97-3.96v-.28l3.97-3.97.09.05 4.7 2.67c1.34.77 1.34 2.01 0 2.78l-4.7 2.67-.1.05z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-red",
    x1: 25.983,
    x2: 4.1259,
    y1: 159.7959,
    y2: 137.9389,
    gradientTransform: "matrix(1 0 0 -1 0 182)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3a44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c31162"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#gradient-red)",
    d: "M28.19 24.06L24.13 20 12.16 31.97c.44.47 1.17.53 2 .06l14.03-7.97"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-green",
    x1: 9.1475,
    x2: 18.9076,
    y1: 181.0399,
    y2: 171.2798,
    gradientTransform: "matrix(1 0 0 -1 0 182)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32a071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2da771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15cf74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06e775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f076"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#gradient-green)",
    d: "M28.19 15.94L14.16 7.97c-.83-.47-1.56-.4-2 .06L24.13 20l4.06-4.06z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M28.1 23.97l-13.94 7.92c-.78.44-1.48.41-1.93 0l-.07.08.07.07c.45.4 1.15.43 1.93-.01l14.03-7.97-.1-.1z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M12.16 31.83c-.28-.3-.44-.76-.44-1.35v.14c0 .6.16 1.05.44 1.35l.07-.07-.07-.07zM32.89 21.25l-4.8 2.72.1.09 4.7-2.67c.67-.38 1-.89 1-1.39-.05.45-.4.9-1 1.25z",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.16 8.11l18.73 10.64c.6.35.95.8 1 1.25 0-.5-.33-1-1-1.39L14.16 7.97c-1.35-.76-2.44-.13-2.44 1.41v.14c0-1.54 1.1-2.17 2.44-1.4z",
    opacity: 0.25
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.5f3c34ac49a91e20dfeb6e3b6fd3def6.svg";
export { ForwardRef as ReactComponent };